import { List, Typography, Card } from 'antd';
import '../styles/App.css';

const { Text, Title } = Typography;

const researcherData = [
    {
        image: process.env.PUBLIC_URL + '/Images/members/gummadi.jpeg',
        name: "Krishna P. Gummadi",
        about: "Krishna Gummadi is a scientific director and head of the Networked Systems research group at the Max Planck Institute for Software Systems (MPI-SWS) in Germany.\
        He also holds a professorship at the University of Saarland.\
        He received his Ph.D. (2005) and B.Tech. (2000) degrees in Computer Science and Engineering from the University of Washington and the Indian Institute of Technology,\
        Madras, respectively.\n\nKrishna's research interests are in the measurement, analysis, design, and evaluation of complex Internet-scale systems.\
        His current projects focus on understanding and building social computing systems. \
        Specifically, they tackle the challenges associated with (1) assessing the credibility of information shared by anonymous online crowds,\
        (2) understanding and controlling privacy risks for users sharing data on online forums,\
        (3) understanding, predicting and influencing human behaviors on social media sites (e.g., viral information diffusion),\
        and (4) enhancing fairness and transparency of machine (data-driven) decision making in social computing systems.\ ",
        website: "https://people.mpi-sws.org/~gummadi/"
    },
    {
        image: process.env.PUBLIC_URL + '/Images/members/ingmar.jpg',
        name: "Ingmar Weber",
        about: "Ingmar is an Alexander von Humboldt Professor in AI at Saarland University where holds the Chair for Societal Computing.\
This interdisciplinary area comprises (i) computing of society, i.e. the measurement of different social phenomena, in particular using non-traditional data sources, and (ii) computing for society, i.e. working with partners on implementing solutions to help address societal challenges.",
        website: "https://ingmarweber.de/"
    },
    {
        image : process.env.PUBLIC_URL + '/Images/members/amukherjee.jpg',
        name : "Animesh Mukherjee",
        about : "Animesh Mukherjee is a Full Professor in the Department of Computer Science and Engineering at the Indian Institute of Technology, Kharagpur. Previously, he worked as a postdoctoral researcher at the Complex Systems Lagrange Lab, ISI Foundation, Italy. He received his PhD from the same department at IIT Kharagpur, where his thesis focused on the self-organization of human speech sound inventories. \
\n\nHis primary research interests lie in content governance, which encompasses (i) content moderation (analysis, detection, and mitigation of harmful content), (ii) content dissemination (fairness challenges in e-commerce platforms and interfaced systems such as facial recognition and automatic speech recognition), and (iii) content maintenance (quality assessment and enhancement of resources such as Wikipedia and large software systems, including Ubuntu releases).",
        website : "https://cse.iitkgp.ac.in/~animeshm/"
    },
    {
        image: process.env.PUBLIC_URL + '/Images/members/zannettou.jpg',
        name: "Savvas Zannettou",
        about: "Savvas Zannettou is an Assistant Professor at TU Delft and an associated researcher at the Max Planck Institute for Informatics.\
 He obtained his PhD in Computer Science from Cyprus University of Technology and during his PhD studies he did internships at Telefonica Research\
 and was a visiting scholar at University of Alabama at Birmingham.\
 \n\nHis research focuses on applying machine learning and data-driven quantitative analysis to understand\
 emerging phenomena on the Web such as the spread of false information and hateful rhetorics.\
 More recently, he is interested on understanding and improving content moderation online, as well as\
 assessing how recommendation algorithms are affecting people's watching habits online on platforms like YouTube and TikTok.\ ",      
      website: "https://zsavvas.github.io/"
    },
    {
        image : process.env.PUBLIC_URL + '/Images/members/adash.jpg',
        name : "Abhisek Dash",
        about : "Abhisek Dash is currently a postdoctoral researcher in Dr. Krishna P. Gummadi’s Networked Systems Research Group at MPI-SWS, Saarbrücken. \
He completed his Ph.D. in Computer Science at the Indian Institute of Technology Kharagpur under the supervision of Dr. Saptarshi Ghosh and Dr. Animesh Mukherjee. \
Prior to that, he earned his M.Tech. in Information Technology from the Indian Institute of Engineering Science and Technology, Shibpur, supervised by Dr. Malay Bhattacharyya.\
\n\nHis research broadly spans computational social science, with a focus on (i) algorithm auditing, including the development of decentralized observatories for platform audits using GDPR provisions; (ii) multimodal analyses of social media data; \
(iii) analyzing how the design and architecture of decentralized social media platforms influence their mechanisms and effectiveness in content moderation; (iv) evaluating the regulatory compliance of digital platforms by developing frameworks to assess their adherence to different provisions and regulations enlisted in data protection laws such as the GDPR, Digital Services Act (DSA), and Digital Markets Act (DMA); and (v) investigating fairness in digital marketplaces.",
        website : "https://sites.google.com/site/abhisek0193/"
    },
    {
        image : process.env.PUBLIC_URL + '/Images/members/skarnam.jpg',
        name : "Sai Keerthana Karnam",
        about : "Sai Keerthana Karnam is a Ph.D. scholar in the Department of Computer Science and Engineering at the Indian Institute of Technology Kharagpur since July 2024, co-advised by Prof. Animesh Mukherjee and Prof. Krishna Gummadi. Before joining PhD, she worked at Adobe. She completed her Bachelors and Masters in same department from the Indian Institute of Technology Kharagpur with the supervision of Prof. Animesh Mukherjee. \
\n\nHer research interests include (i) evaluating the regulatory compliance of social media platforms by developing frameworks to assess their adherence to major data protection and platform governance laws such as the GDPR, Digital Services Act (DSA), and Digital Markets Act (DMA); (ii) algorithm auditing, including the development of decentralized observatories for platform audits using GDPR provisions; and (iii) investigating bias in knowledge graphs like Wikidata.", 
        website : "https://sites.google.com/view/skarnam"
    }
]

function ResearcherCard({ image, name, about, website }) {
    return (
        <Card className="TopMargin">
            <Card.Meta
                avatar={<img className="ResearcherPortrait" src={image} />}
                title={name}
                description={
                    <div>
                        <Text>{about}</Text>
                        <br /><br />
                        <Text strong>{"Website: "}</Text>
                        <a href={website} target="_blank">
                            {website}
                        </a>
                    </div>}
            />
        </Card>
    );
};

export const AboutResearchers = () => {
    return (
        <div>
            <Title level={2}>Our Research Team</Title>
        <List className="Text">
            {researcherData.map((item) => (
                <ResearcherCard {...item} />
            ))}
        </List>
        </div>
    );
}

export default AboutResearchers;